/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

import BallPulse from '../components/BallPulse';

// https://github.com/typescript-eslint/typescript-eslint/issues/2449
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function asyncComponent<P, T extends React.Component<P>>(getComponent: () => Promise<any>) {
  let Component: any = null;
  return class AsyncComponent<P> extends React.Component<P> {
    state = { Component };

    componentDidMount() {
      this.load();
    }

    load() {
      if (Component) {
        return;
      }

      getComponent()
        .then((LoadedComponent: any) => {
          Component = LoadedComponent.default;
          this.setState({ Component: LoadedComponent.default });
        })
        // eslint-disable-next-line no-console
        .catch(console.error);
    }

    render() {
      if (!Component) {
        return (
          <div className="AsyncComponent-loading">
            <BallPulse position="INLINE" />
          </div>
        );
      }

      return <Component {...this.props} />;
    }
  };
}
